import { CriticalError } from "../CriticalError";
import { Loading } from "../Loading";
import { NeedsEmailVerification } from "../NeedsEmailVerification";
import { apiClient } from "../../api/";
import { 
    showComplexSnackbarDispatcher,
    showSnackbar, 
 } from "../../components/";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSearchParams } from "../../hooks/";

/**
 * VerifyEmail page
 */
export const VerifyEmail = () => {
    // Hooks
    const navigate = useNavigate();
    const SearchParams = useSearchParams();

    // useStates
    const [, setError] = useState<boolean>(false);
    const [criticalError, setCriticalError] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);

    const token = SearchParams.get("token");

    // useEffects
    useEffect(() => {
        const verifyEmail = async (token: string) => {
            setLoading(true);

            try {
                const [response, statusOk] = await apiClient.verifyEmail(token);

                if (statusOk) {
                    showSnackbar({ message: `Email successfully verified.`, variant: "success" });
                    navigate("/createProfile");
                } else {
                    setError(true);
                    showComplexSnackbarDispatcher(response as { [key: string]: string[]; });
                }

            } catch (error) {
                setCriticalError(true);
                showSnackbar({ message: String(error), variant: "error" });

            } finally {
                await new Promise(resolve => setTimeout(resolve, 1000));
                setLoading(false);
            }
        };

        if (!token) {
            showSnackbar({ message: "Token may not be blank.", variant: "error" });
            navigate("/signIn");
        } else {
            verifyEmail(token);
        }
    }, [token, navigate]);

    // Early return
    if (criticalError) return <CriticalError />;

    return (
        <>
            <Loading show={loading} />
            <NeedsEmailVerification />
        </>
    );
};